import * as React from 'react'

import { EditorState, EditorView, basicSetup } from '@codemirror/basic-setup'
import { SQLite, sql } from '@codemirror/lang-sql'
import { Box } from '@factorialco/deprecated-design-system'

const formatSchema = (schema: any[]) => {
  return schema.reduce((memo: Record<string, string[]>, table: any) => {
    memo[table.name] = table.fields.map((field: any) => field.key)

    return memo
  }, {})
}

interface Props {
  query: string
  schema: any[]
  onEditorViewChange: (editorView: EditorView) => void
  onQueryChange: (query: string) => void
}

const Terminal = ({ query, schema, onQueryChange, onEditorViewChange }: Props) => {
  const editor = React.useRef(null)
  React.useEffect(() => {
    const formattedSchema = formatSchema(schema)

    const state = EditorState.create({
      doc: query,
      extensions: [
        basicSetup,
        sql({
          dialect: SQLite,
          schema: formattedSchema,
          upperCaseKeywords: true,
        }),
      ],
    })

    const view = new EditorView({
      state,
      parent: editor.current ?? undefined,
      dispatch: (transaction) => {
        view.update([transaction])
        onQueryChange(transaction.state.doc.toString())
      },
    })
    onEditorViewChange(view)

    return () => {
      view.destroy()
    }
  }, [schema]) // eslint-disable-line react-hooks/exhaustive-deps

  return <Box ref={editor} overflowY="scroll" background="grey100" />
}

export default Terminal
